import { ImgHTMLAttributes } from 'react';
import { useS3Image } from '../hooks/useS3Image';
import { Skeleton } from './portal/Skeleton';

interface S3ImageProps extends Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  'src'
> {
  src: string | null | undefined;
  thumbnailSrc?: string | null | undefined;
  useThumbnail?: boolean;
  fallback?: React.ReactNode;
}

export function S3Image({
  src,
  thumbnailSrc,
  useThumbnail = true,
  fallback,
  alt,
  ...props
}: S3ImageProps) {
  const imageSrc = useThumbnail && thumbnailSrc ? thumbnailSrc : src;
  const { imageUrl, isLoading, error } = useS3Image(imageSrc);

  if (isLoading) {
    return (
      <div
        className="size-full overflow-hidden rounded"
        style={{ width: props.width, height: props.height }}
      >
        <Skeleton className="size-full" />
        <span className="sr-only">Loading image…</span>
      </div>
    );
  }

  if (error || !imageUrl) {
    if (fallback) {
      return <>{fallback}</>;
    }
    return (
      <div
        className="flex size-full items-center justify-center rounded bg-seeker-800"
        style={{ width: props.width, height: props.height }}
      >
        <span className="text-xs text-seeker-400">Image unavailable</span>
      </div>
    );
  }

  return <img src={imageUrl} alt={alt} {...props} />;
}
